import React, { PropsWithChildren } from 'react';
import styles from './Banner.module.scss';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import Selectors from 'src/utils/selectors';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';

interface BannerProps {
    icon: JSX.Element;
    text: string;
    boldText?: string;
    className?: string;
    variant?: string;
    'data-cy'?: string;
    linkText?: string;
    onLinkClick?: () => void;
    tag?: string;
    bannerRef?: React.RefObject<HTMLDivElement>;
    href?: string;
    linkDescription?: string;
}

export default function Banner({
    icon,
    text,
    boldText,
    className,
    variant = 'primary',
    'data-cy': dataCy,
    linkText,
    onLinkClick,
    tag,
    href,
    bannerRef,
    linkDescription,
    children
}: PropsWithChildren<BannerProps>): JSX.Element {
    return (
        <div ref={bannerRef} data-cy={dataCy} className={`${className} ${styles.banner} ${variant}Banner`}>
            <div className={styles.bannerIcon}>{icon}</div>
            <div>
                {boldText && (
                    <span className={`${styles.bannerText} ${DlsTypographyVariants.BODY_2}`} data-cy="bannerBoldText">
                        {boldText}
                    </span>
                )}{' '}
                <span
                    className={`${styles.bannerText} ${DlsTypographyVariants.BODY_1}`}
                    data-cy={Selectors.General.BANNER_BODY_TEXT}
                >
                    {text}
                </span>
                {linkText && onLinkClick && (
                    <Anchor
                        onClick={onLinkClick}
                        tag={tag}
                        data-cy={Selectors.General.BANNER_ANCHOR}
                        href={href}
                        aria-label={linkDescription}
                        inline
                    >
                        {linkText}
                    </Anchor>
                )}
            </div>
            {children}
        </div>
    );
}
